import { render, staticRenderFns } from "./SnakeGameDialog.vue?vue&type=template&id=10ae37f4&scoped=true"
import script from "./SnakeGameDialog.vue?vue&type=script&lang=js"
export * from "./SnakeGameDialog.vue?vue&type=script&lang=js"
import style0 from "./SnakeGameDialog.vue?vue&type=style&index=0&id=10ae37f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ae37f4",
  null
  
)

export default component.exports